export const DROPS = "drops";

export function hasFeatureFlag(userDetails, flag) {
    return userDetails.featureFlags?.includes(flag) === true;
}
